import App from "./../app.jsx";
import { Outlet } from "react-router-dom";
import Home from "../pages/dashboard/dashboard.js";
import Error from "./../pages/error/error.js";
import ExtraError from "./../pages/extra/extra-error.js";
import Login from "./../pages/user/login.js";
import PrivateRoute from "./PrivateRoute";
import ManageStaff from "../pages/staff/manageStaff.js";
import AddStaff from "../pages/staff/AddStaff.js";
import UpdateStaff from "../pages/staff/updateStaff.js";
import UpdatePassword from "../pages/staff/UpdatePassword.jsx";
import WeeklySchedule from "../pages/staff/weeklySchedule.js";
import ManageCompany from "../pages/compnay/manageCompnay.jsx";
import AddCompany from "../pages/compnay/addcompany.js";
import UpdateCompany from "../pages/compnay/updateCompany.js";
import ManagePaymentProviders from "../pages/paymentProvider/managePaymentProviders.jsx";
import ManagePaymentGatewayPlatforms from "../pages/paymentGatewayPlatform/managePaymentGatewayPlatforms.jsx";
import ManageMarketplaceCampaigns from "../pages/marketplaceCampaign/manageMarketplaceCampaigns.jsx";
import ManageMarketplaceRiders from "../pages/marketplaceRider/manageMarketplaceRiders.jsx";
import AddMarketplaceRider from "../pages/marketplaceRider/addMarketplaceRider.jsx";
import UpdateMarketplaceRider from "../pages/marketplaceRider/updateMarketplaceRider.jsx";
import ManageRiderRemittances from "../pages/marketplaceRider/manageRiderRemittances.jsx";
import ManageRiderCreditLimits from "../pages/marketplaceRider/manageRiderCreditLimits.jsx";
import ManageRiderPayouts from "../pages/marketplaceRider/manageRiderPayouts.jsx";
import ManageRiderPerformanceRules from "../pages/marketplaceRider/manageRiderPerformanceRules.jsx";
import ManageRiderViolationHistory from "../pages/marketplaceRider/manageRiderViolationHistory.jsx";
import LiveDispatchMonitor from "../pages/marketplaceRider/liveDispatchMonitor.jsx";
import MarketplacePerformance from "../pages/marketplacePerformance/marketplacePerformance.jsx";
import MarketplaceRiderPerformance from "../pages/marketplacePerformance/marketplaceRiderPerformance.jsx";
import MarketplaceOrderTimeline from "../pages/marketplacePerformance/marketplaceOrderTimeline.jsx";
import ManageRestaurantSettlements from "../pages/marketplaceRestaurant/manageRestaurantSettlements.jsx";
import ManageRiderShiftSlots from "../pages/marketplaceRiderShifts/manageRiderShiftSlots.jsx";
import ManageMarketplaceZones from "../pages/marketplaceZones/manageMarketplaceZones.jsx";
import ManageDeliveryFeeSlabs from "../pages/marketplaceDeliveryFees/manageDeliveryFeeSlabs.jsx";
import MarketplaceOrderTimeoutSettings from "../pages/marketplaceOrderTimeouts/settings.jsx";
import MarketplaceRestaurantPenalties from "../pages/marketplaceOrderTimeouts/penalties.jsx";
import ManageAllergens from "../pages/allergen/manageAllergens.jsx";
import ManagePackages from "../pages/packages/managePackages.jsx";
import AddPackage from "../pages/packages/addPackage.jsx";
import UpdatePackage from "../pages/packages/updatePackage.jsx";
import ManageAddons from "../pages/addons/manageAddons.jsx";
import AddAddon from "../pages/addons/addAddon.jsx";
import UpdateAddon from "../pages/addons/updateAddon.jsx";
import ManageQuotes from "../pages/quotes/manageQuotes.jsx";
import BulkUploadProducts from "../pages/bulkUpload/BulkUploadProducts.jsx";
import BulkUploadGuide from "../pages/bulkUpload/BulkUploadGuide.jsx";
import ManageUnits from "../pages/units/manageUnits.jsx";
import ManageMarketplaceCustomers from "../pages/customer/manageMarketplaceCustomers.jsx";
import ManageResturantCategories from "../pages/resturantCategory/manageResturantCategories.jsx";
import ManageBankAccounts from "../pages/billing/manageBankAccounts.jsx";
import PaymentSettings from "../pages/billing/paymentSettings.jsx";
import SupportSettings from "../pages/support/supportSettings.jsx";
import ManagePosAppReleases from "../pages/appReleases/managePosAppReleases.jsx";
import Revenue from "../pages/revenue/revenue.jsx";
import RevenueCompanies from "../pages/revenue/revenueCompanies.jsx";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "user/*",
        element: <Outlet />,
        children: [
          { path: "login", element: <Login /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "staff/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageStaff", element: <ManageStaff /> },
          { path: "AddStaff", element: <AddStaff /> },
          { path: "UpdateStaff/:UserName", element: <UpdateStaff /> },
          { path: "updatePassword/:UserName", element: <UpdatePassword /> },
          { path: "weeklySchedule/:UserName", element: <WeeklySchedule /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "company/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageCompany", element: <ManageCompany /> },
          { path: "addCompany", element: <AddCompany /> },
          { path: "updateCompany/:CompID", element: <UpdateCompany /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "paymentProvider/*",
        element: <PrivateRoute />,
        children: [
          { path: "managePaymentProviders", element: <ManagePaymentProviders /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "paymentGatewayPlatform/*",
        element: <PrivateRoute />,
        children: [
          { path: "managePaymentGatewayPlatforms", element: <ManagePaymentGatewayPlatforms /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketplaceCampaign/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageCampaigns", element: <ManageMarketplaceCampaigns /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketplaceRider/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageRiders", element: <ManageMarketplaceRiders /> },
          { path: "addRider", element: <AddMarketplaceRider /> },
          { path: "updateRider/:riderId", element: <UpdateMarketplaceRider /> },
          { path: "liveDispatch", element: <LiveDispatchMonitor /> },
          { path: "remittances", element: <ManageRiderRemittances /> },
          { path: "creditLimits", element: <ManageRiderCreditLimits /> },
          { path: "payouts", element: <ManageRiderPayouts /> },
          { path: "performanceRules", element: <ManageRiderPerformanceRules /> },
          { path: "violationHistory", element: <ManageRiderViolationHistory /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketplacePerformance/*",
        element: <PrivateRoute />,
        children: [
          { path: "overview", element: <MarketplacePerformance /> },
          { path: "riders", element: <MarketplaceRiderPerformance /> },
          { path: "timeline", element: <MarketplaceOrderTimeline /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketplaceRestaurant/*",
        element: <PrivateRoute />,
        children: [
          { path: "settlements", element: <ManageRestaurantSettlements /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketplaceRiderShifts/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageShifts", element: <ManageRiderShiftSlots /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketplaceZones/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageZones", element: <ManageMarketplaceZones /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketplaceDeliveryFees/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageSlabs", element: <ManageDeliveryFeeSlabs /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "marketplaceOrderTimeouts/*",
        element: <PrivateRoute />,
        children: [
          { path: "settings", element: <MarketplaceOrderTimeoutSettings /> },
          { path: "penalties", element: <MarketplaceRestaurantPenalties /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "allergen/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageAllergens", element: <ManageAllergens /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "units/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageUnits", element: <ManageUnits /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "customer/*",
        element: <PrivateRoute />,
        children: [
          { path: "marketplaceCustomers", element: <ManageMarketplaceCustomers /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "resturantCategory/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageResturantCategories", element: <ManageResturantCategories /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "packages/*",
        element: <PrivateRoute />,
        children: [
          { path: "managePackages", element: <ManagePackages /> },
          { path: "addPackage", element: <AddPackage /> },
          { path: "updatePackage/:packageID", element: <UpdatePackage /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "addons/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageAddons", element: <ManageAddons /> },
          { path: "addAddon", element: <AddAddon /> },
          { path: "updateAddon/:addonID", element: <UpdateAddon /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "billing/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageBankAccounts", element: <ManageBankAccounts /> },
          { path: "paymentSettings", element: <PaymentSettings /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "support/*",
        element: <PrivateRoute />,
        children: [
          { path: "supportSettings", element: <SupportSettings /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "quotes/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageQuotes", element: <ManageQuotes /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "bulkUpload/*",
        element: <PrivateRoute />,
        children: [
          { path: "bulkUploadProducts", element: <BulkUploadProducts /> },
          { path: "bulkUploadGuide", element: <BulkUploadGuide /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "appReleases/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageAppReleases", element: <ManagePosAppReleases /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          { path: "dashboard", element: <Home /> },
          { path: "revenue", element: <Revenue /> },
          { path: "revenue/companies", element: <RevenueCompanies /> },
          { path: "*", element: <Error /> },
        ],
      },
    ],
  },
];
export default AppRoute;
